import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// NOTE: withCredentials is intentionally false. The platform's ingress responds
// with Access-Control-Allow-Origin: *, which browsers reject when combined with
// credentialed requests. We rely on the Bearer token returned by /auth/login
// and stored in localStorage instead.
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
  headers: { "Content-Type": "application/json" },
});

// Attach Bearer token on every request
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("access_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
